import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    doorDivisions: [],
    doorFillings: [],
    gableFillings: [],
    gableOptions: [],
    impactFillings: [],
    inventory: [],
    inventoryCategories: [],
    shipmentMethods: [],
    wardrobePositions: []
  },
  mutations: {
    setApiData (state, dataFromAPI) {
      Vue.set(state, 'doorDivisions', dataFromAPI.door_divisions);
      Vue.set(state, 'doorFillings', dataFromAPI.door_fillings);
      Vue.set(state, 'gableFillings', dataFromAPI.gable_fillings);
      Vue.set(state, 'gableOptions', dataFromAPI.gable_options);
      Vue.set(state, 'impactFillings', dataFromAPI.impact_fillings);
      Vue.set(state, 'inventory', dataFromAPI.inventory);
      Vue.set(state, 'inventoryCategories', dataFromAPI.inventory_categories);
      Vue.set(state, 'wardrobePositions', dataFromAPI.wardrobe_positions);
      Vue.set(state, 'shipmentMethods', dataFromAPI.shipment_methods);
    }
  },
  getters: {
    optionsDoorDivisions: (state) => state.doorDivisions,
    getAvailableOptionsDoorDivisions: (state) => (wardrobeHeight) => state.doorDivisions.filter(item => item.max_height >= wardrobeHeight),
    optionsDoorFillings: (state) => state.doorFillings,
    optionsGableFillings: (state) => state.gableFillings,
    optionsGable: (state) => state.gableOptions,
    optionsImpactFillings: (state) => state.impactFillings,
    optionsInventory: (state) => state.inventory,
    optionsInventoryCategories: (state) => state.inventoryCategories,
    optionsWardrobePositions: (state) => state.wardrobePositions,
    optionsShipmentMethods: (state) => state.shipmentMethods,
  }
};
